export const institutionalProps = {
  basename: "/",
};
